import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Privacy() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <main id="page-content-layer">
        <div className="privacyPolicyPage_main__Fnm2m">
          <h1 className="textHeadingL_className__KQ29Z">
            Privacy Policy and Cookies
          </h1>
          <p className="textBodyS_className__i7HOx">
            Latest version:{" "}
            <time dateTime="2025-10-14T14:23:41.855Z">14/10/2025</time>
          </p>
          <h2 className="textHeadingL_className__KQ29Z">
            Data protection information
          </h2>
          <section className="SectionParagraphList_content__0Uxag">
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                Who is the data controller for the processing of your data?
              </h3>
              <div>
                <p>
                  The Data Controller for personal data collected and processed
                  on our platforms ("platforms" refers to use of the Mangoes
                  website, app or the devices in our physical stores, as well as
                  those derived from your relationship with Mangoes) is{" "}
                  <span className="textBodyMStrong_className__yXgeE">
                    Mangoes MNG, S.A. (Mangoes), with Corporate Tax ID no.
                    A-59.088.948.
                  </span>{" "}
                  You can contact Mangoes via the following means:
                </p>
                <ul>
                  <li>
                    <span className="textBodyMStrong_className__yXgeE">
                      Postal address:
                    </span>
                    Customer Services, Via Augusta, 10 (Polígono Industrial
                    Riera Caldes), 08184 Palau-Solità i Plegamans (Barcelona),
                    Spain.
                  </li>
                  <li>
                    <span className="textBodyMStrong_className__yXgeE">
                      E-mail:
                    </span>
                    life@manyou.fun
                  </li>
                </ul>
                <p>
                  In certain cases, the Data Controller is not Mangoes MNG, S.A.
                  "Mangoes", but one of its subsidiaries. For further details,
                  please consult the section entitled "When are subsidiaries
                  data controllers?".
                </p>
                <p>
                  Mangoes has appointed a Data Protection Officer who you may
                  contact and/or raise any issue relating to the processing of
                  your personal data by sending an e-mail to{" "}
                  <Link
                    onClick={toTop}
                    className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                    to="mailto:life@manyou.fun"
                    data-testid="mng-link"
                    target=""
                  >
                    <span className="textBodyMStrong_className__yXgeE">
                      life@manyou.fun
                    </span>
                  </Link>
                  <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                    <span className="textBodyMStrong_className__yXgeE" />
                  </span>{" "}
                  or by sending your query to the following postal address: DPO
                  Office, C/ Mercaders 9-11 (Polígono Industrial Riera Caldes),
                  08184 Palau-Solità i Plegamans (Barcelona), Spain.
                </p>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                What type of personal information does Mangoes collect and
                process?
              </h3>
              <div>
                <p>
                  Mangoes may collect from your relationship and use of our
                  services, the following data and/or data categories:i)
                  identification and contact data; ii) personal information;
                  iii) financial data, such as credit card data (PAN+CVV2), in
                  compliance with PCI DSS standards, which will be used for
                  payment processing whenever you purchase any of our items or,
                  in the case of returns for transfers, the account number for
                  which we need to process the refund of your purchase; iv) data
                  observed in the purchasing of our products and consumer habits
                  and preferences of our customers; v) user data of Manyou’s
                  platforms.
                </p>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                For what purpose do we process your personal information and
                what is the lawful basis?
              </h3>
              <div>
                <p>
                  At Mangoes we may process your personal information for the
                  following purposes:
                </p>
                <p>
                  <span className="textBodyMStrong_className__yXgeE">
                    A) CREATION OF A USER ACCOUNT
                  </span>
                </p>
                <ul>
                  <li>
                    Manage your registration, which will involve the{" "}
                    <span className="textBodyMStrong_className__yXgeE">
                      creation of a Mangoes user account.
                    </span>{" "}
                    This account will allow you to centralise any issue relating
                    to your user status, and give you access to certain
                    functions available and reserved for those with said status.
                    For example, having a user account will allow you to store
                    certain information that may be used in future purchases
                    and/or interactions with Mangoes.{" "}
                  </li>
                </ul>
                <p>
                  Furthermore, the creation of a user account will allow you to
                  participate in the{" "}
                  <span className="textBodyMStrong_className__yXgeE">
                    Mangoes Likes You loyalty programme
                  </span>
                  , in countries where it is available. Registration on this
                  programme may result in discounts and/or benefits in the
                  services of third-party collaborators, as well as discounts on
                  your future purchases at Mangoes. In this regard, we inform
                  you that countries that dispose of the Mangoes Likes You
                  loyalty programme will publish this on their respective
                  websites.{" "}
                </p>
                <ul>
                  <li>
                    The lawful basis that legitimises the processing of your
                    data for this purpose is the execution of a contract,
                    understood as such the accepted Terms &amp; Conditions.
                  </li>
                  <li>
                    At the time of account creation. The processing of your data
                    is necessary to ensure compliance with the obligations and
                    rights provided for in the Terms &amp; Conditions.
                  </li>
                </ul>
                <p>
                  <span className="textBodyMStrong_className__yXgeE">
                    B) PURCHASE OF Mangoes PRODUCTS
                  </span>
                </p>
                <p />
                <p>
                  <span className="textBodyMStrong_className__yXgeE">
                    Process the purchase of items via the different purchasing
                    channels enabled by Mangoes.
                  </span>{" "}
                  This procedure consists of taking all the appropriate steps in
                  order to manage your purchase and, wherever applicable,
                  guarantee the correct delivery of your order, in addition to
                  undertaking any procedure related to the sale of the item such
                  as, for example, the management and issue of proof purchase
                  documents such as the simplified electronic invoice, the sales
                  or Tax Free invoice and, wherever applicable, managing the
                  return of the items.
                </p>
                <p>
                  To do this, we may send you information about the status of
                  the purchase by e-mail, SMS and/or any other channel available
                  at any moment.
                </p>
                <ul>
                  <li>
                    The lawful basis for the processing of your data for this
                    purpose is the{" "}
                    <span className="textBodyMStrong_className__yXgeE">
                      execution of a contract
                    </span>{" "}
                    understanding as such the Conditions of Sale accepted at the
                    moment of purchasing the items. The processing of your data
                    is necessary to guarantee the fulfilment of the rights and
                    obligations contained in the Conditions of Sale.
                  </li>
                </ul>
                <p />
                <p>
                  <span className="textBodyMStrong_className__yXgeE">
                    Management of the Mangoes Gift Card
                  </span>
                </p>
                <ul>
                  <li>
                    The lawful basis for the processing of your data for this
                    purpose is the{" "}
                    <span className="textBodyMStrong_className__yXgeE">
                      execution of a contract
                    </span>{" "}
                    understanding as such the Conditions of Use accepted at the
                    time of purchasing the card. The processing of your data is
                    necessary to guarantee the fulfilment of the rights and
                    obligations contained in the Conditions of Use.
                  </li>
                </ul>
                <p />
                <p>
                  With regard to the processing of online purchases, Mangoes, as
                  data controller, will carry out the corresponding actions for
                  the{" "}
                  <span className="textBodyMStrong_className__yXgeE">
                    prevention, detection and control of abuse and fraud in the
                    use of our services{" "}
                  </span>
                  , which may result in the existence of automated decision
                  making.
                </p>
                <p>
                  Said automated decisions shall consist of the analysis of
                  behaviour in the payment process which, in general terms, will
                  use data relating to the purchasing process and the purchase
                  history, in order to determine whether the transaction may be
                  considered fraudulent. This information will allow us to
                  detect and try to prevent fraudulent practices in payment
                  transactions, allowing us to reject purchases and consequently
                  protect both you, as a data subject (in the case of identity
                  theft), and Mangoes as a service provider and data controller.
                </p>
                <ul>
                  <li>
                    The lawful basis for the processing of your data to fulfil
                    this goal is the{" "}
                    <span className="textBodyMStrong_className__yXgeE">
                      legitimate interest
                    </span>{" "}
                    of Mangoes to analyse all the operations that occur in the
                    payment process of the products it sells to ensure that no
                    economic fraud will occur that impact negatively on itself
                    or its customers. In this regard, we consider that there is
                    a general interest for the processing to help generate,
                    improve and maintain public confidence in the financial
                    relationships developed through the payment methods made
                    available by Mangoes in its online commerce, in order to
                    prevent public mistrust resulting from fraud or fraudulent
                    activity in the same.
                  </li>
                  <li>
                    We inform you that, in this case, Mangoes has compelling and
                    legitimate grounds to enable the processing of your data for
                    this purpose, for which your right to opposition in
                    accordance with the provisions of article 21.1 of the
                    General Data Protection Regulation shall not apply.
                  </li>
                  <li>
                    You can obtain more information about said evaluation by
                    making a direct request to our Data Protection Officer.
                  </li>
                </ul>
                <p />
                <p>
                  <span className="textBodyMStrong_className__yXgeE">
                    In cases where you are registered as a user and purchase{" "}
                  </span>
                  one of our items via our platforms, we may carry out the
                  following data processing:
                </p>
                <ul>
                  <li>
                    <span className="textBodyMStrong_className__yXgeE">
                      Save your credit card details for use in future purchases
                    </span>
                    .
                  </li>
                </ul>
                <p>
                  The lawful basis for the processing of your data is the{" "}
                  <span className="textBodyMStrong_className__yXgeE">
                    express consent
                  </span>{" "}
                  given by you for us to save this information for use in future
                  purchases, without prejudice to the legitimate use of your
                  credit card data in the execution of a contract, in line with
                  what is indicated in the previous section. This consent may be
                  withdrawn at any time without said withdrawal affecting the
                  lawfulness of the processing based on your consent prior to
                  withdrawal.
                </p>
                <p />
                <p>
                  <span className="textBodyMStrong_className__yXgeE">
                    C) CONFIGURE YOUR RELATIONSHIP WITH Mangoes AS A BRAND
                  </span>
                </p>
                <p />
                <p>
                  <span className="textBodyMStrong_className__yXgeE">
                    Newsletter: management and sending of commercial information
                    on exclusive promotions and new products adapted to your
                    profile, sending audiences via digital platforms, and
                    notifications relative to pending garments and accessories
                    in your shopping bag{" "}
                  </span>
                  via e-mail, SMS, WhatsApp, notifications from the Mangoes App
                  or any other communication channel and/or digital platform.
                  This includes promotional actions such as, for example, the
                  management of competitions and prize draws organised by
                  Mangoes. In cases where you agree to receive commercial
                  notifications via different channels, certain personal
                  information may be used to personalise notifications via
                  online means.
                </p>
                <ul>
                  <li>
                    The lawful basis for the processing of your data is the{" "}
                    <span className="textBodyMStrong_className__yXgeE">
                      express consent
                    </span>{" "}
                    given by you, which you may withdraw it at any time without
                    said withdrawal affecting the lawfulness of the processing
                    based on your consent prior to withdrawal.
                  </li>
                </ul>
                <p />
                <p>
                  <span className="textBodyMStrong_className__yXgeE">
                    Management of the alerts service to notify the availability
                    of garments and accessories{" "}
                  </span>
                  via our Mangoes App, e-mail, SMS, WhatsApp or any other
                  communication channel and/or digital platform.
                </p>
                <ul>
                  <li>
                    The lawful basis for the processing of your data for this
                    purpose is the{" "}
                    <span className="textBodyMStrong_className__yXgeE">
                      express consent
                    </span>{" "}
                    given by you, which you may withdraw it at any time without
                    said withdrawal affecting the lawfulness of the processing
                    based on your consent prior to withdrawal.
                  </li>
                </ul>
                <p />
                <p>
                  <span className="textBodyMStrong_className__yXgeE">
                    Garment search service in Mangoes stores (localisation).{" "}
                  </span>
                  Mangoes will process your personal data in order to indicate
                  the availability of the selected garment in the stores closest
                  to the location provided by your device. We will not
                  subsequently retain this data on our systems.
                </p>
                <ul>
                  <li>
                    The lawful basis for the processing of your data for this
                    purpose is the{" "}
                    <span className="textBodyMStrong_className__yXgeE">
                      consent{" "}
                    </span>
                    given by you to access the location of your device.
                  </li>
                </ul>
                <p>
                  This consent may be withdrawn at any time without said
                  withdrawal affecting the lawfulness of the processing based on
                  your consent prior to withdrawal.
                </p>
                <p />
                <p>
                  <span className="textBodyMStrong_className__yXgeE">
                    Respond to the exercise of the rights recognised in the data
                    protection legislation
                  </span>
                  .
                </p>
                <ul>
                  <li>
                    The lawful basis for the processing of your data is the{" "}
                    <span className="textBodyMStrong_className__yXgeE">
                      fulfilment of a legal obligation{" "}
                    </span>
                    with regard to managing the exercise of rights, in
                    accordance with the obligation contained in the General Data
                    Protection Regulation.
                  </li>
                </ul>
                <p />
                <p>
                  <span className="textBodyMStrong_className__yXgeE">
                    Attend to queries, requests and possible complaints that you
                    make via Customer Service channels,{" "}
                  </span>
                  such as postal mail, telephone, e-mail, WhatsApp, Social
                  Media, forms in the Mangoes App/Web, virtual assistant in the
                  App/Web with AI capabilities and any other channel enabled for
                  this purpose. Depending on the reason you are contacting
                  Mangoes, the lawful basis for the processing of your data may
                  vary. In this regard:
                </p>
                <ul>
                  <li>
                    We consider that Mangoes has a{" "}
                    <span className="textBodyMStrong_className__yXgeE">
                      legitimate interest
                    </span>{" "}
                    to correctly resolve and respond to the suggestions, queries
                    or requests that you make via Customer Service channels, on
                    the understanding that, under no circumstances, will your
                    rights and/or freedoms be affected or prejudiced by the fact
                    that we are responding to a request initiated by you.
                  </li>
                  <li>
                    <span className="textBodyMStrong_className__yXgeE">
                      In cases where this relates to an order that needs to be
                      attended to formalise the purchase, the lawful basis for
                      the processing of your data is the execution of a contract
                      understanding as such the Conditions of Sale.
                    </span>
                  </li>
                  <span className="textBodyMStrong_className__yXgeE" />
                  <li>
                    <span className="textBodyMStrong_className__yXgeE">
                      In cases where your data is processed to attend to a
                      complaint sent via the Customer Services channel, the
                      lawful basis for the processing of your data is the
                      fulfilment of a legal obligation
                    </span>{" "}
                    contained in the General Law for the Defence of Consumers
                    and Users.
                  </li>
                </ul>
                <p />
                <p>
                  After providing any of our services, send you{" "}
                  <span className="textBodyMStrong_className__yXgeE">
                    quality surveys aimed at finding out your opinion and degree
                    of satisfaction
                  </span>{" "}
                  with your dealings with Mangoes. The information collected as
                  a result of the survey will allow us to create and improve our
                  services and procedures, said experience being of considerable
                  interest to us.
                </p>
                <ul>
                  <li>
                    The lawful basis for the processing of your data is the{" "}
                    <span className="textBodyMStrong_className__yXgeE">
                      legitimate interest.
                    </span>
                    Our legitimate interest consists of being able to guarantee
                    that our platforms remain secure, as well as to help Mangoes
                    understand the needs, expectations and your degree of
                    satisfaction with the brand and, therefore, improve our
                    services at all times. All these actions are carried out in
                    order to improve your degree of satisfaction and ensure a
                    unique browsing and purchasing experience, via aggregated
                    analysis.
                  </li>
                </ul>
                <p />
                <p>
                  <span className="textBodyMStrong_className__yXgeE">
                    Profiling{" "}
                  </span>
                  based on behavioral and consumption data collected through
                  your browsing, your interactions with the brand and those
                  derived from your purchase history in order to show you
                  priority recommendations or content on our platform, in
                  accordance with your preferences, as well as sending you
                  commercial notifications adapted to your profile, provided you
                  have given us your consent for this purpose.
                </p>
                <ul>
                  <li>
                    Taking into account the characteristics of the profiling and
                    after balancing your interests as the data subject, and
                    those of Mangoes as the data controller, it has been
                    determined that the lawful basis for the processing of your
                    data is the{" "}
                    <span className="textBodyMStrong_className__yXgeE">
                      legitimate interest
                    </span>{" "}
                    deeming that it is in the interest of all parties involved
                    that such priority items may be of interest to the consumer.
                    Consequently, by showing items that may reflect the
                    priorities of the user in question as a matter of priority,
                    Mangoes will be able to offer you a better quality service
                    and a more positive user experience, while At the same time,
                    the fact that users have a positive experience, while giving
                    Mangoes a reputational benefit based on the fact that users
                    will have a positive browsing and shopping experience on our
                    platforms.
                  </li>
                  <li>
                    Taking into account the characteristics of the profiling and
                    after balancing your interests as the data subject, and
                    those of Mangoes as the data controller, it has been
                    determined that the lawful basis for the processing of your
                    data for consumer profiling, in order to send you commercial
                    notifications adapted to the interests, tastes and
                    preferences of consumers, is the{" "}
                    <span className="textBodyMStrong_className__yXgeE">
                      legitimate interest{" "}
                    </span>
                    deeming that it is in the interest of all parties involved
                    to send personalised commercial notifications. Consequently,
                    being able to adapt commercial notifications to your user
                    profile will allow Mangoes to offer you a better quality
                    service since you will only receive notifications whose
                    content may be of interest to you, thus avoiding the sending
                    of generic notifications which may be excessive or of little
                    interest to the data subjects. This will increase your
                    degree of satisfaction and, in turn, benefit Mangoes, since
                    it will be able to send more effective commercial
                    notifications that favour the capture of new customers and
                    gain the loyalty of existing ones, while also improving its
                    commercial image.
                  </li>
                  <li>
                    The profiling algorithm does not formulate recommendations
                    on actions to take (neither in terms of segment nor on an
                    individual basis) and does not apply automated
                    decision-making either, but merely analyses the consumer
                    behaviour of customers and potential customers in order to
                    know their interests, tastes and preferences by predicting
                    the future consumer behaviour of the data subject. Based on
                    this information, a Marketing manager will decide what it
                    the best strategy for said segment, customer or potential
                    customer.
                  </li>
                  <li>
                    You can obtain more information on the evaluation of
                    legitimate interest by making a request directly to our Data
                    Protection Officer.
                  </li>
                </ul>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                How long do we keep your personal information?
              </h3>
              <div>
                <p>
                  In order to guarantee that the personal information are
                  appropriate, pertinent and limited to what is necessary for
                  the purposes for which they are processed, Mangoes will keep
                  your personal information only for a period that is reasonably
                  necessary to fulfil the purpose for which they were collected,
                  given the requirements to respond to issues that are raised or
                  to resolve problems, make improvements, activate services and
                  fulfil the requirements of the applicable legislation. This
                  means that we may keep your personal information for a
                  reasonable time, including after you have stopped using the
                  services of Mangoes and/or have stopped using its
                  platforms.After this period, your personal information will be
                  blocked in all Mangoes systems for the sole purpose of making
                  them available to the competent authorities in order to attend
                  to any potential administrative or legal responsibilities and
                  the exercise or defence of complaints. Once the blocking
                  period for personal information has passed, they will be
                  permanently deleted.
                </p>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                Who do we share your personal information with?
              </h3>
              <div>
                <p>
                  Your personal data may be shared with Mangoes Group companies
                  for internal administrative purposes based on legitimate
                  interest.
                </p>
                <p>
                  Your personal data will be communicated to third parties in
                  order to comply with any legal obligations that may apply in
                  each case, for example, to Public Authorities and/or Bodies
                  whenever required by the applicable tax, employment or Social
                  Security legislation, or any other that may apply.
                </p>
                <p>
                  In cases where you make a purchase on our platforms, your data
                  may be communicated, wherever applicable, to financial
                  institutions and payment service providers, fraud detection
                  and prevention organisations, for example Signifyd, and
                  logistics, transport and goods delivery suppliers. Such
                  communications are strictly necessary in order to guarantee
                  the delivery of your order.
                </p>
                <p>
                  You are also informed that Mangoes may contract third parties
                  that will have access to your data as the result of a service
                  provision we have entered into. Such third parties may provide
                  technology, customer service, marketing and advertising
                  services, among others, and in all cases will process your
                  data in accordance with the instructions of Mangoes and never
                  for their own purposes.
                </p>
                <p>
                  Mangoes shall not, under any circumstances, sell your personal
                  data to third parties.
                </p>
                <p>
                  In the cases indicated in the section "When are subsidiaries
                  data controllers?" of the present Privacy Policy, in which the
                  Data Controller is the subsidiary, Mangoes may act as Data
                  processor insofar as it provides the subsidiaries a customer
                  and post-purchase satisfaction survey management service.
                </p>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                International transfers
              </h3>
              <div>
                <p>
                  International data transfers may occur in cases where the
                  companies that Mangoes shares your data with are located
                  outside the European Economic Area. These are lawful, since
                  appropriate guarantees to protect personal information have
                  been established.In cases where the destination country is not
                  covered by an adequacy decision, Mangoes will regulate the
                  relationship with the third-party destination country shall by
                  subscribing to the Standard Contractual Clauses adapted by the
                  European Commission, whose contents may be consulted via the
                  following link{" "}
                  <Link
                    onClick={toTop}
                    className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                    to="/"
                  >
                    <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                      <span className="textBodyMStrong_className__yXgeE">
                        https://ec.europa.eu/info/law/law-topic/data-protection/international-dimension-data-protection/standard-contractual-clauses-scc_en
                      </span>
                    </span>
                  </Link>
                </p>
                <p>
                  In all cases, third parties sharing certain personal
                  information will have previously accredited the adoption of
                  suitable technical and organisational measures for the correct
                  protection of the same.
                </p>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                Data not collected directly from the data subject{" "}
              </h3>
              <div>
                <p>
                  In certain services offered via our platforms, such as Gift
                  Cards, the user may provide personal information to the
                  recipient of the same. In this case, Mangoes will also comply
                  with its obligations in accordance with the provisions
                  contained in the data protection legislation, processing them
                  solely for the purpose for which they have been provided to
                  us.
                </p>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                How does Mangoes protect your personal information?
              </h3>
              <div>
                <p>
                  Our platforms use data security technologies such as network
                  and application firewalls, anti-automated threat systems,
                  access control procedures and cryptographic mechanisms to
                  prevent any unauthorised access to data and guarantee data
                  confidentiality. Periodic security audits and frequent
                  controls are also carried out to make risk assessments. In
                  order to achieve said aims, users accept that Mangoes will
                  obtain data for the purpose of authenticating access controls.
                </p>
                <p />
                <p>
                  Furthermore, all transactions via our platforms will be made
                  via secure payment systems. Confidential payment details are
                  transmitted directly in encrypted format to the corresponding
                  entity.
                </p>
                <p />
                <p>
                  Mangoes declares that it has adopted all the technical and
                  organisational measures necessary to guarantee the security
                  and integrity of the personal information it processes, and to
                  prevent the loss, alteration and/or unauthorised use of the
                  same by third parties.
                </p>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                What are your privacy rights in relation to your personal
                information?
              </h3>
              <div>
                <p>
                  Your rights are set out below.You may exercise them via the
                  e-mail address{" "}
                  <span className="textBodyMStrong_className__yXgeE">
                    life@manyou.fun
                  </span>
                  In order to process your request to exercise your rights, we
                  may ask you to provide proof of your identity.
                </p>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>Right of access</p>
                      </td>
                      <td>
                        <p>
                          You have the right to obtain confirmation whether at
                          Mangoes processing personal information that concern
                          you, or otherwise, and to access the personal
                          information Mangoes possesses about you.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Right to rectification</p>
                      </td>
                      <td>
                        <p>
                          You have the right to request that Mangoes rectifies
                          personal information when they are incorrect or for
                          them to be completed when they are incomplete. In
                          cases where you have a user account, you should
                          correct your data directly by accessing the “My data”
                          section of your profile.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Right of erasure</p>
                      </td>
                      <td>
                        <p>
                          You can request that your personal information is
                          erased when, among other reasons, the data is no
                          longer necessary for the purposes for which they were
                          collected.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Right to restrict processing</p>
                      </td>
                      <td>
                        <p>
                          You have the right to request the restriction of the
                          processing of your data, in which case we will only
                          keep them for the exercise or defence of legal claims.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Right to data portability</p>
                      </td>
                      <td>
                        <p>
                          You have the right to receive personal information in
                          a structured, commonly used and machine-readable
                          format, and to transmit them to another controller
                          when the treatment is based on consent or the
                          execution of a contract, provided they are transmitted
                          by automated means.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Right to object</p>
                      </td>
                      <td>
                        <p>
                          You can object to the processing of your personal
                          details based on the public or legitimate interest
                          pursued by Mangoes, including the profiling of data.
                          In this case, Mangoes will stop processing the data,
                          except for compelling legal grounds or when necessary
                          for the exercise or defence of possible legal claims.
                          You also have the right to object to the processing of
                          data for direct marketing purposes.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Automated individual decisions</p>
                      </td>
                      <td>
                        <p>
                          Wherever this applies, you have the right not to be
                          subject to a decision based solely on automated
                          processing, including data profiling, which has a
                          legal or similarly significant effect on you. However,
                          it will not be possible to exercise said right in
                          cases where the decision is necessary for the
                          formalisation or execution of a contract between you
                          and Mangoes; it is authorised by the law applicable to
                          Mangoes whenever it establishes the appropriate
                          measures to safeguard your rights, freedoms and
                          legitimate interests; or where it is based on your
                          explicit consent.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Right to submit a complaint</p>
                      </td>
                      <td>
                        <p>
                          You have the right to lodge a complaint before the
                          competent local Supervisory Authority, which in Spain
                          is the Spanish Data Protection Agency (www.aepd.es).
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                Modifications to the privacy policy
              </h3>
              <div>
                <p>
                  This privacy policy will be available at all times. However,
                  in cases where we modify the content of the same in a
                  substantial and significant way, we shall notify you via our
                  platforms or to your e-mail address, in order to comply with
                  the duty of information contained in the GDPR. Consequently,
                  if you wish, you may exercise your rights as a data subject.
                </p>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                When are subsidiaries data controllers?
              </h3>
              <div>
                There are certain situations in which the Data Controller is not{" "}
                <span className="textBodyMStrong_className__yXgeE">
                  Mangoes MNG, S.A.
                </span>
                “Manyou”, but one of its subsidiaries.
                <p>
                  In this regard, each of the subsidiaries identified in the
                  following table{" "}
                  <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                    will be responsible for processing the personal data of
                    customers who purchase in the physical store located in the
                    country where the subsidiary is located
                  </span>
                  , when their data is processed for the following purposes:
                </p>
                <ul>
                  <li>
                    Processing the purchase of items. This process consists of
                    carrying out all necessary actions to manage the purchase of
                    products sold through its own establishments.
                  </li>
                  <li>
                    Responding to queries, requests and potential complaints
                    that you make through the contact channels enabled by
                    Customer Service.
                  </li>
                  <li>
                    Sending quality surveys to discover customer opinions and
                    their level of post-purchase satisfaction.
                  </li>
                </ul>
                <p />
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <span className="textBodyMStrong_className__yXgeE">
                          COMPANY
                        </span>
                      </td>
                      <td>
                        <span className="textBodyMStrong_className__yXgeE">
                          COUNTRY
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes MNG, S.A
                          </span>
                        </p>
                        <p>Via Augusta, 10 (POL.IND.RIERA DE CALDES)</p>
                        <p>08184</p>
                        <p>Palau de Plegamans.</p>
                        <p>España</p>
                        <p>A59088948</p>
                      </td>
                      <td>SPAIN</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes France SARL
                          </span>
                        </p>
                        <p>Rue Lafayette 43</p>
                        <p>75009</p>
                        <p>Paris</p>
                        <p>France</p>
                        <p>Siret: 403 259 138 01315</p>
                      </td>
                      <td>FRANCE</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes Italia SRL
                          </span>
                        </p>
                        <p>Vicolo Santa Maria alla Porta n.1</p>
                        <p>20123</p>
                        <p>Milano</p>
                        <p>Italia</p>
                        <p>Codice Fiscale 04996900967</p>
                      </td>
                      <td>ITALY</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes Deutschland GmbH, Textilhandel
                          </span>
                        </p>
                        <p>Rheinlanddamm 199</p>
                        <p>44139</p>
                        <p>Dortmund</p>
                        <p>Deutschland</p>
                        <p>Steuernummer: 314/5722/5875</p>
                      </td>
                      <td>GERMANY</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes T.R TEKSTIL TICARET LIMITED ŞİRKETİ
                          </span>
                        </p>
                        <p>
                          Katip Çelebi Mahallesi İstiklal Cad. No: 81 / 9
                          Beyoğlu
                        </p>
                        <p>34433</p>
                        <p>Istanbul</p>
                        <p>Türkiye</p>
                        <p>V.D: 6120096964</p>
                      </td>
                      <td>TURKEY</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            MNG Mangoes UK Limited
                          </span>
                        </p>
                        <p>6th Floor, Manfield House, 1 Southampton Street,</p>
                        <p>WC2R 0LR</p>
                        <p>London</p>
                        <p>Tax ID: 108230257</p>
                      </td>
                      <td>UNITED KINGDOM</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            ManyouNOR COMERCIO DE VESTUARIO S.A.
                          </span>
                        </p>
                        <p>Rua Fradesso da Silveira, 6, 3º A Complexo</p>
                        <p>Alcântara Rio, Bloco C</p>
                        <p>1300-609</p>
                        <p>Lisboa</p>
                        <p>Portugal</p>
                        <p>VAT: PT503662682</p>
                      </td>
                      <td>PORTUGAL</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes Polska Sp.z.o.o.
                          </span>
                        </p>
                        <p>Ul. Inflancka 4</p>
                        <p>00-189</p>
                        <p>Warszawa</p>
                        <p>Poland</p>
                        <p>5262467859</p>
                      </td>
                      <td>
                        <p>POLAND</p>
                        <p />
                        <p />
                        <p />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes Nederland B.V.
                          </span>
                        </p>
                        <p>Postbus 8764</p>
                        <p>3009AT</p>
                        <p>Rotterdam</p>
                        <p>BTW-Nummer: 808217355B02</p>
                      </td>
                      <td>NETHERLANDS</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes Hong Kong Ltd
                          </span>
                        </p>
                        <p>
                          Room 1101, 11/F., China Insurance Group Building, 141
                          Des Voeux Road Central
                        </p>
                        <p>Hong Kong</p>
                        <p>Company number: 868087</p>
                      </td>
                      <td>HONG KONG</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes GARMENTS ROM SRL
                          </span>
                        </p>
                        <p>
                          Strada Popa Petre nr.5, corp A, et.5, biroul nr.510
                        </p>
                        <p>sector 2</p>
                        <p>Bucharest</p>
                        <p>Romania</p>
                        <p>Tax number: RO 24199564</p>
                      </td>
                      <td>
                        <p>ROMANIA</p>
                        <p />
                        <p />
                        <p />
                        <p />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            MNG-Mangoes Belgique, SPRL
                          </span>
                        </p>
                        <p>Chaussée de la Hulpe, 178</p>
                        <p>1170</p>
                        <p>Bruxelles</p>
                        <p>Belgique</p>
                        <p>Tax number: BE0465370861</p>
                      </td>
                      <td>BELGIUM</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes MODA d. o. o.
                          </span>
                        </p>
                        <p>Savska 106</p>
                        <p>10000</p>
                        <p>Zagreb</p>
                        <p>Hrvatska</p>
                        <p>OIB: HR40126080386</p>
                      </td>
                      <td>CROATIA</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes Österreich Handels -gmbH
                          </span>
                        </p>
                        <p>Gertrude-Fröhlich-Sandner- Straße 1/Top 13</p>
                        <p>1100</p>
                        <p>Wien</p>
                        <p>Österreich</p>
                        <p>UID: U49204007</p>
                      </td>
                      <td>AUSTRIA</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes (CZ) s.r.o.
                          </span>
                        </p>
                        <p>Na Prikope 8</p>
                        <p>11000</p>
                        <p>Praha 1</p>
                        <p>Česká Republika</p>
                        <p>Tax number: CZ26143291</p>
                      </td>
                      <td>CZECH REPUBLIC</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes SUISSE SA
                          </span>
                        </p>
                        <p>
                          p.a. Fiduciaire de Preux &amp; Associés SA, Rampe du
                          Pont-Rouge 5a, Casse Postale 1671
                        </p>
                        <p>1211</p>
                        <p>Genève 26</p>
                        <p>Suisse</p>
                        <p>TVA: CHE101380208</p>
                      </td>
                      <td>SWITZERLAND</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes Danmark Aps
                          </span>
                        </p>
                        <p>Dirch Passers Allé 76</p>
                        <p>2000</p>
                        <p>Frederiksberg</p>
                        <p>Danmark</p>
                        <p>CVR: 10019869</p>
                      </td>
                      <td>DENMARK</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes Hungary KFT.
                          </span>
                        </p>
                        <p>Dévai u. 26-28</p>
                        <p>1134</p>
                        <p>Budapest</p>
                        <p>Hungary</p>
                        <p>Adólg.sz.:11913047-2-41</p>
                      </td>
                      <td>HUNGARY</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            MNG Mangoes IRELAND Ltd
                          </span>
                        </p>
                        <p>3rd Floor, 40 Mespil Road</p>
                        <p>D04 C2N4</p>
                        <p>Dublin 4</p>
                        <p>Ireland</p>
                        <p>VAT: 9671807W</p>
                      </td>
                      <td>IRELAND</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes BULGARIA EOOD
                          </span>
                        </p>
                        <p>2a, Saborna Street, floor 4</p>
                        <p>1000</p>
                        <p>Sofia</p>
                        <p>Bulgaria</p>
                        <p>VAT: BG202941171</p>
                      </td>
                      <td>BULGARIA</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes Suomi OY
                          </span>
                        </p>
                        <p>PL 54</p>
                        <p>00811</p>
                        <p>Helsinki</p>
                        <p>Finland</p>
                        <p>Business-ID: 2110861-9</p>
                      </td>
                      <td>FINLAND</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes Garments Hellas, S.A.
                          </span>
                        </p>
                        <p>350 Sygrou Av.</p>
                        <p>17674</p>
                        <p>Kallithea</p>
                        <p>Greece</p>
                        <p>VAT: 094456433</p>
                      </td>
                      <td>GREECE</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes Sverige AB
                          </span>
                        </p>
                        <p>Box 1024</p>
                        <p>10138</p>
                        <p>Stockholm</p>
                        <p>Sverige</p>
                        <p>VAT: 556660267701</p>
                      </td>
                      <td>SWEDEN</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes Slovensko s.r.o.
                          </span>
                        </p>
                        <p>Hodžovo námestie 1A</p>
                        <p>811 06</p>
                        <p>Bratislava</p>
                        <p>Slovenská Republika</p>
                        <p>VAT: SK2022284561</p>
                      </td>
                      <td>SLOVAKIA</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes Meritxell S.L.U.
                          </span>
                        </p>
                        <p>Prat de la Creu, 59-65, Escala D, 3era Planta,</p>
                        <p>AD500</p>
                        <p>Andorra la Vella</p>
                        <p>Principat d'Andorra</p>
                        <p>NRT: L-704126-K</p>
                      </td>
                      <td>ANDORRA</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes SL d.o.o.
                          </span>
                        </p>
                        <p>Linhartova 11a</p>
                        <p>1000</p>
                        <p>Ljubljana</p>
                        <p>Slovenia</p>
                        <p>Tax number: 89299442</p>
                      </td>
                      <td>SLOVENIA</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes Norge AS
                          </span>
                        </p>
                        <p>Postboks 1942 Vika</p>
                        <p>0125</p>
                        <p>Oslo</p>
                        <p>Norge</p>
                        <p>MVA: NO979881614MVA</p>
                      </td>
                      <td>
                        <p>NORWAY</p>
                        <p />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes LUXEMBOURG S.à.r.l
                          </span>
                        </p>
                        <p>46A, Avenue J.F. Kennedy</p>
                        <p>1855</p>
                        <p>Luxembourg</p>
                        <p>TVA: 2013 2420 107</p>
                      </td>
                      <td>
                        <p>LUXEMBOURG</p>
                        <p />
                        <p />
                        <p />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes SINGAPORE GARMENTS PTE. LTD
                          </span>
                        </p>
                        <p>36 Robinson Road, #20-01 City House</p>
                        <p>68877</p>
                        <p>Singapore</p>
                        <p>VAT: 201117871R</p>
                      </td>
                      <td>SINGAPORE</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes UKRAINE LLC
                          </span>
                        </p>
                        <p>23-A Yaroslaviv Val St., 2nd floor</p>
                        <p>01054</p>
                        <p>Kyiv</p>
                        <p>Ukraine</p>
                        <p>VAT: 387789926565</p>
                      </td>
                      <td>UKRAINE</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes Korea Ltd
                          </span>
                        </p>
                        <p>
                          4/F., Haesung Building 942, Daechi-dong, Gangnam-gu
                        </p>
                        <p>Seoul</p>
                        <p>South Korea</p>
                        <p>Tax number: 113-86-58480</p>
                      </td>
                      <td>SOUTH KOREA</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes NY INC
                          </span>
                        </p>
                        <p>405 Lexington Avenue, 26th Floor</p>
                        <p>10174</p>
                        <p>New York</p>
                        <p>USA</p>
                        <p>Tax ID/FEIN: 20-2434061</p>
                      </td>
                      <td>USA</td>
                    </tr>
                  </tbody>
                </table>
                <p />
                <p>
                  Similarly, each of the subsidiaries identified in the
                  following table{" "}
                  <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                    will be responsible for the processing of the personal data
                    of customers who purchase through their web store or App
                  </span>
                  , when their personal data is processed for the following
                  purposes:
                </p>
                <ul>
                  <li>
                    Processing the purchase of items. This management consists
                    of carrying out all the appropriate actions in order to
                    manage the purchase of products sold through its e-commerce,
                    and guaranteeing the correct delivery of your order.
                  </li>
                  <li>
                    Responding to queries, requests and possible complaints that
                    you make through the contact channels enabled by Customer
                    Service.
                  </li>
                  <li>
                    Sending quality surveys to discover customer opinions and
                    their level of post-purchase satisfaction.
                  </li>
                </ul>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <span className="textBodyMStrong_className__yXgeE">
                          COMPANY
                        </span>
                      </td>
                      <td>
                        <span className="textBodyMStrong_className__yXgeE">
                          COUNTRY
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes T.R TEKSTIL TICARET LIMITED ŞİRKETİ
                          </span>
                        </p>
                        <p>
                          Katip Çelebi Mahallesi İstiklal Cad. No: 81 / 9
                          Beyoğlu
                        </p>
                        <p>34433</p>
                        <p>Istanbul</p>
                        <p>Türkiye</p>
                        <p>V.D: 6120096964</p>
                      </td>
                      <td>TURKEY</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            MNG Mangoes UK Limited
                          </span>
                        </p>
                        <p>6th Floor, Manfield House, 1 Southampton Street,</p>
                        <p>WC2R 0LR</p>
                        <p>London</p>
                        <p>Tax ID: 108230257</p>
                      </td>
                      <td>UNITED KINGDOM</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes NY INC
                          </span>
                        </p>
                        <p>405 Lexington Avenue, 26th Floor</p>
                        <p>10174</p>
                        <p>New York</p>
                        <p>USA</p>
                        <p>Tax ID/FEIN: 20-2434061</p>
                      </td>
                      <td>USA</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes SUISSE SA
                          </span>
                        </p>
                        <p>
                          p.a. Fiduciaire de Preux &amp; Associés SA, Rampe du
                          Pont-Rouge 5a, Casse Postale 1671
                        </p>
                        <p>1211</p>
                        <p>Genève 26</p>
                        <p>Suisse</p>
                        <p>TVA: CHE101380208</p>
                      </td>
                      <td>SWITZERLAND</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes Norge AS
                          </span>
                        </p>
                        <p>Postboks 1942 Vika</p>
                        <p>0125</p>
                        <p>Oslo</p>
                        <p>Norge</p>
                        <p>MVA: NO979881614MVA</p>
                      </td>
                      <td>
                        <p>MORWAY</p>
                        <p />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes SINGAPORE GARMENTS PTE. LTD
                          </span>
                        </p>
                        <p>36 Robinson Road, #20-01 City House</p>
                        <p>68877</p>
                        <p>Singapore</p>
                        <p>VAT: 201117871R</p>
                      </td>
                      <td>SINGAPORE</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes OPERACIONES MEXICO S DE RL DE CV
                          </span>
                        </p>
                        <p>
                          Campos Eliseos 169 Interior 202, Col. Polanco
                          Chapultepec, Miguel Hidalgo
                        </p>
                        <p>11560</p>
                        <p>México DF</p>
                        <p>México</p>
                        <p>RFC: MOM140206925</p>
                      </td>
                      <td>MEXICO</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes BULGARIA EOOD
                          </span>
                        </p>
                        <p>2a, Saborna Street, floor 4</p>
                        <p>1000</p>
                        <p>Sofia</p>
                        <p>Bulgaria</p>
                        <p>VAT: BG202941171</p>
                      </td>
                      <td>BULGARIA</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes ON LINE CANADA CORPORATION
                          </span>
                        </p>
                        <p>1 Place Ville Marie, 39th Floor</p>
                        <p>H3B 2B6</p>
                        <p>Montreal, QC</p>
                        <p>Canadá</p>
                      </td>
                      <td>CANADA</td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Mangoes MNG, S.A
                          </span>
                        </p>
                        <p>Via Augusta, 10 (POL.IND.RIERA DE CALDES)</p>
                        <p>08184</p>
                        <p>Palau de Plegamans.</p>
                        <p>España</p>
                        <p>A-59088948 </p>
                      </td>
                      <td>OTHER COUNTRIES</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">Cookies Policy</h3>
              <div />
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                What are cookies and how are they used?
              </h3>
              <div>
                <p>
                  Cookies are files installed on the user's computer, phone,
                  tablet or any other device, with the purpose of recording the
                  user's activities during their browsing time on this website
                  and/or the Mangoes mobile application ("Web/App"). Through the
                  use of cookies, it is possible for the server where the
                  Web/App is located to recognize the browser used by the user,
                  allowing, for example, the registered user to access areas and
                  services without having to register on each visit and remember
                  their language, country preferences, etc. on future visits.
                  Cookies are also used to measure audience and traffic
                  parameters, control progress and number of entries.
                </p>
                <p>
                  In relation to the concept of "Cookie", we also refer to other
                  technologies similar to cookies that, in a similar way, allow
                  storing or retrieving certain information from a device such
                  as, for example, flash cookies, web beacons or bugs, pixels,
                  HTML5 (local storage), and SDK technology for App formats, as
                  well as the use of fingerprinting techniques to identify the
                  device of the interested party.
                </p>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                What does Mangoes use cookies for?
              </h3>
              <div>
                <p>
                  During access and navigation on the website or through the use
                  of the mobile app, Mangoes may store or record IP addresses,
                  user preferences or the type of device used for the main
                  purposes of (i) compiling statistics related to the number of
                  visits or web traffic; (ii) offering a more personalized
                  browsing experience; and (iii) remembering sign in data, even
                  on different devices, and (iv) displaying advertising, on this
                  page or others, based on browsing habits within our website.
                </p>
                <p>
                  Similarly, we do not store sensitive personal identification
                  information such as your address, your password, etc., in the
                  cookies we use.
                </p>
                <p>
                  Mangoes does not sell customer data to third parties in any
                  case.
                </p>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                Who uses the information stored in the cookies?
              </h3>
              <div>
                <p>
                  The information stored in the Web/App cookies is used by
                  Mangoes MNG, S.A.. (“Manyou”), with N.I.F. A-59.088.948:
                </p>
                <ul>
                  <li>
                    Postal address: Via Augusta, 10 (Polígono Industrial Riera
                    Caldes) 08184 Palau-solità i Plegamans (Barcelona, Spain).
                  </li>
                  <li>
                    Email:{" "}
                    <Link
                      onClick={toTop}
                      className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                      to="mailto:life@manyou.fun"
                      data-testid="mng-link"
                      target=""
                    >
                      life@manyou.fun
                    </Link>
                    <br />
                  </li>
                </ul>
                <p>
                  Also, some of the cookies that may be installed are not owned
                  by Mangoes but by third parties, you can consult the complete
                  list of cookies used by Mangoes in the configuration panel
                  which you will find below.
                </p>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                What type of cookies does Mangoes use?
              </h3>
              <div>
                <p>
                  Below are the types of cookies used on the Mangoes Web/App,
                  based on the type of cookies according to their purpose and
                  the entity that manages them (own and third-party).
                </p>
                <table>
                  {" "}
                  <tbody>
                    {" "}
                    <tr>
                      {" "}
                      <td>
                        {" "}
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Management
                          </span>
                        </p>{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Description
                          </span>
                        </p>{" "}
                      </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td>
                        {" "}
                        <p>Self-managed cookies</p>{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <p>
                          These are those that are created or managed by
                          Mangoes, as the person responsible for the Web/App.
                        </p>{" "}
                      </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td>
                        {" "}
                        <p>Third-party cookies</p>{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <p>
                          These are those that are managed by service providers
                          unrelated to Mangoes. These are identified in the
                          configuration panel which you can access from
                          <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                            {" "}
                            the "configure cookies" button that you will find
                            below.
                          </span>
                          <br />
                          <br />
                        </p>{" "}
                      </td>{" "}
                    </tr>
                  </tbody>
                </table>
                <table>
                  {" "}
                  <tbody>
                    {" "}
                    <tr>
                      {" "}
                      <td>
                        {" "}
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Purpose
                          </span>
                        </p>{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <p>
                          <span className="textBodyMStrong_className__yXgeE">
                            Description
                          </span>
                        </p>{" "}
                      </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td>
                        {" "}
                        <p>Strictly necessary cookies</p>{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <p>
                          These cookies are necessary for the website to
                          function and cannot be deactivated in our systems.
                          They are usually configured to respond to actions made
                          by you to receive services, such as adjusting your
                          privacy preferences, signing in to your account, or
                          completing forms. You can configure your browser to
                          block or alert the presence of these cookies, but some
                          parts of the website will not work. These cookies do
                          not store any personally identifiable information.
                        </p>{" "}
                      </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td>
                        {" "}
                        <p>Preference or customization cookies</p>{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <p>
                          These are those that allow you to access the service
                          remembering predefined characteristics based on a
                          series of criteria such as, for example, the language,
                          the type of browser through which the service is
                          accessed, the regional configuration from where the
                          service is accessed, etc.
                        </p>{" "}
                        <p>
                          Not accepting these cookies could generate slow
                          performance or poorly adapted recommendations.
                        </p>{" "}
                      </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td>
                        {" "}
                        <p>Analysis cookies</p>{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <p>
                          These are those that, treated by us or by third
                          parties, allow us to quantify the number of users and
                          thus carry out the measurement and statistical
                          analysis of the use that users make of the offered
                          service. For this, your navigation on our website is
                          analyzed in order to improve the offer of products or
                          services that we offer you.
                        </p>{" "}
                      </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td>
                        {" "}
                        <p>Behavioral advertising cookies</p>{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <p>
                          These are those that, treated by us or by third
                          parties, allow us to analyze your browsing habits on
                          the Internet so that we can show you advertising
                          related to your browsing profile.
                        </p>{" "}
                      </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td>
                        {" "}
                        <p>Social Network Cookies</p>{" "}
                      </td>{" "}
                      <td>
                        {" "}
                        <p>
                          These are those that are set by a series of social
                          network services, that we have added to the site, to
                          allow you to share our content with your friends and
                          networks.
                        </p>{" "}
                      </td>{" "}
                    </tr>
                  </tbody>
                </table>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                How to disable cookies in the most commonly-used web browsers
              </h3>
              <div>
                <p>
                  You can allow, block or delete the cookies installed on your
                  computer in the settings options of your web browser.If you
                  block them, certain services that require their use may not be
                  available to you.
                </p>
                <p>
                  Below, we provide some links to information on how to enable
                  your preferences on the most commonly-used web browsers:
                </p>
                <p>
                  <Link
                    onClick={toTop}
                    className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                    to="/"
                  >
                    <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                      <span className="textBodyMStrong_className__yXgeE">
                        Google Chrome
                      </span>
                    </span>
                  </Link>
                  <span className="textBodyMStrong_className__yXgeE" />
                </p>
                <p>
                  <span className="textBodyMStrong_className__yXgeE" />
                  <Link
                    onClick={toTop}
                    className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                    to="/"
                  >
                    <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                      <span className="textBodyMStrong_className__yXgeE">
                        Mozilla Firefox
                      </span>
                    </span>
                  </Link>
                  <span className="textBodyMStrong_className__yXgeE" />
                </p>
                <p>
                  <span className="textBodyMStrong_className__yXgeE" />
                  <Link
                    onClick={toTop}
                    className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                    to="/"
                  >
                    <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                      <span className="textBodyMStrong_className__yXgeE">
                        Internet Explorer
                      </span>
                    </span>
                  </Link>
                  <span className="textBodyMStrong_className__yXgeE" />
                </p>
                <p>
                  <span className="textBodyMStrong_className__yXgeE" />
                  <Link
                    onClick={toTop}
                    className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                    to="/"
                  >
                    <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                      <span className="textBodyMStrong_className__yXgeE">
                        Safari
                      </span>
                    </span>
                  </Link>
                  <span className="textBodyMStrong_className__yXgeE" />
                </p>
                <p>
                  <span className="textBodyMStrong_className__yXgeE" />
                  <Link
                    onClick={toTop}
                    className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                    to="/"
                  >
                    <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                      <span className="textBodyMStrong_className__yXgeE">
                        Opera
                      </span>
                    </span>
                  </Link>
                </p>
                <p>
                  If you have accepted the third-party cookies, you can delete
                  them from your web browser options or from the system offered
                  by the third-party itself.
                </p>
                <p>
                  We invite you to consult how third parties manage your
                  personal data through their privacy policies, which are
                  available on their respective platforms. For example, in the
                  case of Google, you can find this information on the{" "}
                  <Link
                    onClick={toTop}
                    className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                    to="/"
                  >
                    <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                      <span className="textBodyMStrong_className__yXgeE">
                        Google Business Safety Site
                      </span>
                    </span>
                    .
                  </Link>
                </p>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                Conservation periods
              </h3>
              <div>
                <p>
                  Mangoes will retain the personal data collected only for the
                  specified, provided, and limited period necessary to fulfill
                  the purpose for which they were collected, as well as to
                  comply with the requirements of applicable legislation. Once
                  the intended purpose is fulfilled, your data will be properly
                  blocked for the period during which legal actions may arise
                  and, once the prescription period has passed, they will be
                  properly deleted.
                </p>
                <p>
                  Similarly, the data obtained through the use of cookies
                  accepted by the user will be kept for a period of 13 months
                  and, consequently, once this period has passed, a new consent
                  will be requested when you visit our WEB/APP.
                </p>
                <p>
                  Regarding the third parties identified in the cookie settings
                  panel, you can consult their retention period in their
                  respective privacy policies.
                </p>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                Data transfers to third countries
              </h3>
              <div>
                <p>
                  Generally, data processing is carried out by service providers
                  located within the European Economic Area or in countries that
                  have been declared to have an adequate level of protection.
                </p>
                <p>
                  In the event of international data transfers to countries that
                  do not have a decision of adequacy from the European
                  Commission, Mangoes will use the Standard Contractual Clauses
                  adapted by the European Commission as a guarantee for those
                  transfers in compliance with Items 44 to 49 of the 2016/679
                  Data Protection Regulation. In any case, the third parties
                  with whom personal data is shared will have previously
                  accredited the adoption of adequate technical and
                  organizational measures for the correct protection of the
                  data.
                </p>
                <p>
                  In relation to third parties that manage cookies, you can
                  inform yourself about the transfers to third countries that,
                  where appropriate, they carry out in their corresponding
                  cookie policies.
                </p>
              </div>
            </article>
            <article className="SectionParagraph_contentText__4GBlt">
              <h3 className="textHeadingL_className__KQ29Z">
                How to manage your consent preferences
              </h3>
              <div>
                <p>
                  You can configure the categories of optional cookies by
                  clicking on the cookie settings button below:
                </p>
              </div>
            </article>
          </section>
          <button
            className="ButtonBase_button__SOIgU textActionM_className__8McJk ButtonPrimary_default__2Mbr8 CookiesButton_button__41ycI"
            type="button"
            aria-disabled="false"
          >
            <span className="ButtonContentWrapper_content__BD7dT">
              Set cookies
            </span>
          </button>
        </div>
        <div>
          <div className="Footer_footer__QfTV6">
            <h2 className="Footer_title__lArUt textBodyMStrong_className__yXgeE">
              10% off your next purchase by subscribing to the newsletter
            </h2>
            <form className="Form_form__HUtjp Footer_form__P1da_">
              <div className="Form_inputContainer__HYdK1">
                <div className="Input_inputWrapper__7tx4D">
                  <div className="Input_box__vAdaB">
                    <label
                      className="Input_label___ONtC textBodyM_className__v9jW9"
                      htmlFor="newsletter-form-email-input"
                    >
                      E-mail
                    </label>
                    <input
                      aria-invalid="false"
                      className="Input_input__sA8hs textBodyL_className__8D1Ya"
                      id="newsletter-form-email-input"
                      placeholder=""
                      type="text"
                      autoComplete="email"
                      aria-required="true"
                      name="email"
                      defaultValue=""
                    />
                  </div>
                </div>
                <button
                  className="ButtonBase_button__SOIgU textActionM_className__8McJk ButtonBase_fullWidth__g0ppN Form_submitButton__d1dGu ButtonSecondary_default__LzUq_"
                  id="newsletter-form-submit-button"
                  type="submit"
                >
                  <span className="ButtonContentWrapper_content__BD7dT">
                    Sign up now
                  </span>
                </button>
              </div>
              <dialog
                id="newsletter-generic-modal"
                className="Modal_modalTypeL__QvHdt Modal_dialog__ivY6s"
              />
            </form>
            <div className="ExpandableTextByLink_expandableContent__EwFxh textLegalS_className__3wL71 Footer_legal__YIebs">
              <p id="newsletter-policy">
                By subscribing, you confirm that you have read the{" "}
                <button
                  type="button"
                  id="expand-checkbox"
                  className="ExpandableTextByLink_expander__ST8Mr GenericStyles_anchor__uq5eo textBodyLinkS_className__gkmfD"
                  aria-expanded="false"
                >
                  Privacy Policy
                </button>
                .
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </body>
  );
}

export default Privacy;
